import { FC, useState } from "react";
import {
  useAlertStore,
  useGeneralStore,
  usePopupStore,
  useThemeStore,
} from "../../../stores";
import {
  FactorSearchFormFields,
  FactorSearchFormSetters,
} from "../../../components/factor/factor-search-form/types";
import { FactorDetails, FactorSearchForm } from "../../../components/factor";
import {
  Customer,
  Factor,
  FactorType,
  FactorTypeName,
  ObjectId,
} from "../../../types";
import { Column } from "../../../components/containers";
import { AlignItems } from "../../../components/containers/types";
import { Heading, Text } from "../../../components/typography";
import { FactorApi } from "../../../api";
import Table from "../../../components/table";
import { TableRendererProps } from "../../../components/table/types";
import { addComma, factorTypeToString } from "../../../utils";

const INIT_FORM: FactorSearchFormFields = {
  customer: null,
  description: "",
  totalPrice: 0,
  type: null,
};

const SearchFactor: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const getCustomerById = useGeneralStore((s) => s.getCustomerById);
  const [formData, setFormData] = useState<FactorSearchFormFields>({
    ...INIT_FORM,
  });

  const getSetters = (): FactorSearchFormSetters => {
    return {
      setCustomer: (v) =>
        setFormData((prev) => ({ ...prev, customer: v as Customer | null })),
      setDescription: (v) =>
        setFormData((prev) => ({ ...prev, description: v as string })),
      setTotalPrice: (v) =>
        setFormData((prev) => ({ ...prev, totalPrice: v as number })),
      setType: (v) =>
        setFormData((prev) => ({ ...prev, type: v as FactorType | null })),
    };
  };

  const [factors, setFactors] = useState<Array<Factor>>([]);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  const onSearch = (): void => {
    setFactors([]);
    FactorApi.search(formData)
      .then((res) => {
        setFactors(res);
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      });
  };

  const findFactor = (part: any): Factor[] => {
    const sc: Factor[] = factors.filter((c) => c._id.$oid === part._id.$oid);
    return sc;
  };

  return (
    <>
      <div
        style={{
          background: theme.overlay,
          borderRadius: 15,
          marginTop: "1rem",
          padding: "1rem",
        }}
      >
        <FactorSearchForm
          {...formData}
          {...getSetters()}
          buttons={["search"]}
          onSearch={onSearch}
        />
      </div>

      <Column
        style={{ minHeight: 70, marginTop: "1rem" }}
        alignItems={AlignItems.Start}
        gap={10}
      >
        <Heading size={18} color={theme.textOnBg}>
          نتایج
        </Heading>

        <div
          style={{
            overflowX: "auto",
            width: "calc(100% - 20px)",
            background: theme.overlay,
            padding: "20px 10px",
            borderRadius: 15,
          }}
        >
          <Table<{
            customer: ObjectId;
            description: string;
            total_price: number;
            type: FactorTypeName;
          }>
            data={factors}
            label={{
              customer: "مشتری",
              description: "بابت",
              total_price: "کل مبلغ",
              type: "نوع فاکتور",
            }}
            renderer={{
              customer: ({ props }: TableRendererProps) => (
                <Text size={12} color={theme.textOnOverlay}>
                  {getCustomerById(props.$oid)?.fullname || ""}
                </Text>
              ),
              description: ({ props }: TableRendererProps) => (
                <Text size={12} color={theme.textOnOverlay}>
                  {props}
                </Text>
              ),
              total_price: ({ props }: TableRendererProps) => (
                <Text size={12} color={theme.textOnOverlay}>
                  {addComma(props)}
                </Text>
              ),
              type: ({ props }: TableRendererProps) => (
                <Text size={12} color={theme.textOnOverlay}>
                  {factorTypeToString(props)}
                </Text>
              ),
            }}
            layout={{
              customer: 200,
              description: 200,
              total_price: 150,
              type: 120,
            }}
            rowEvents={[
              {
                type: "click",
                handler: (e, data) => {
                  const sf = findFactor(data);
                  if (!sf.length) return;
                  setPopupBody(
                    <FactorDetails factor={sf[0]} updateCb={onSearch} />
                  );
                },
              },
            ]}
          />
        </div>
      </Column>
    </>
  );
};

export default SearchFactor;
